import React from "react";
import { PriceInput } from "../input-number";
import { ChosenPriceDisabledTooltip } from "./chosen-price-disabled-tooltip";
import styles from "./sidebar-price-input-single.module.css";

const { number: numberClassName } = styles as any;

type SingleProps = {
  chosen: number | null;
  onChange: (value: number) => void;
  disabled: boolean;
  currencySymbol: string;
  phaseLevelPricing: boolean;
  topDownPricing: boolean;
};

const SidebarPriceInputSingleDisabled: React.FC<{
  chosen: number | null;
  currencySymbol: string;
  phaseLevelPricing: boolean;
  topDownPricing: boolean;
}> = ({ chosen, currencySymbol, phaseLevelPricing, topDownPricing }) => {
  return (
    <ChosenPriceDisabledTooltip
      phaseLevelPricing={phaseLevelPricing}
      topDownPricing={topDownPricing}
    >
      <PriceInput
        currencySymbol={currencySymbol}
        size="small"
        className={numberClassName}
        step={100}
        placeholder="Price"
        value={chosen!}
        disabled={true}
      />
    </ChosenPriceDisabledTooltip>
  );
};
const SidebarPriceInputSingleEnabled: React.FC<Omit<SingleProps, "disabled">> = ({
  chosen,
  onChange,
  currencySymbol,
}) => (
  <PriceInput
    currencySymbol={currencySymbol}
    size="small"
    className={numberClassName}
    step={100}
    placeholder="Price"
    value={chosen!}
    onChange={onChange}
  />
);
export const SidebarPriceInputSingle: React.FC<SingleProps> = ({ disabled, ...others }) => {
  return disabled ? (
    <SidebarPriceInputSingleDisabled {...others} />
  ) : (
    <SidebarPriceInputSingleEnabled {...others} />
  );
};
